// Client API — wrapper attorno a fetch verso gli endpoint PHP.
// Tutte le richieste inviano il cookie di sessione con credentials: 'include'.

const BASE = "/api";

async function apiRequest(
  path,
  { method = "GET", body, headers, isMultipart = false } = {}
) {
  const opts = {
    method,
    credentials: "include",
    headers: {
      Accept: "application/json",
      // NON impostiamo Content-Type per multipart: il browser aggiunge il boundary
      ...(isMultipart ? {} : { "Content-Type": "application/json" }),
      ...(headers || {}),
    },
  };

  if (body !== undefined) {
    opts.body = isMultipart ? body : JSON.stringify(body);
  }

  const res = await fetch(`${BASE}${path}`, opts);
  const contentType = res.headers.get("content-type") || "";
  const isJson = contentType.includes("application/json");
  const data = isJson ? await res.json() : await res.text();

  if (!res.ok) {
    // Il backend PHP invia { error: "...", detail: "..." } per i 500.
    // Mostriamo il detail quando presente perché "Errore server" da solo
    // non aiuta a capire (es. tabella mancante, colonna sbagliata, ecc.).
    const base = (data && data.error) || `Errore ${res.status}`;
    const detail = data && data.detail;
    const message = detail && detail !== base ? `${base}: ${detail}` : base;
    const err = new Error(message);
    err.status = res.status;
    err.data = data;
    throw err;
  }

  // Se la risposta non è JSON, l'endpoint non ha funzionato come atteso
  // (es. dev server locale che serve index.html per /api/*).
  if (!isJson) {
    const err = new Error(
      `Risposta non-JSON da ${path} (endpoint non raggiungibile in questo ambiente)`
    );
    err.status = res.status;
    throw err;
  }

  return data;
}

// Auth
export const login = (email, password) =>
  apiRequest("/login.php", { method: "POST", body: { email, password } });

export const logout = () => apiRequest("/logout.php", { method: "POST" });

export const getMe = () => apiRequest("/me.php");

// Form pubblici
export const submitContatto = (data) =>
  apiRequest("/contatti.php", { method: "POST", body: data });

// Submissions admin
export const listSubmissions = (params = {}) => {
  const q = new URLSearchParams();
  if (params.unread) q.set("unread", "1");
  const qs = q.toString();
  return apiRequest(`/submissions.php${qs ? "?" + qs : ""}`);
};

export const markSubmissionRead = (id, isRead) =>
  apiRequest(`/submissions.php?id=${id}`, {
    method: "PATCH",
    body: { is_read: isRead },
  });

export const deleteSubmission = (id) =>
  apiRequest(`/submissions.php?id=${id}`, { method: "DELETE" });

// Prodotti
export const listProducts = ({ all = false } = {}) =>
  apiRequest(`/products.php${all ? "?all=1" : ""}`);

export const getProduct = (id) => apiRequest(`/products.php?id=${id}`);

export const createProduct = (data) =>
  apiRequest("/products.php", { method: "POST", body: data });

export const updateProduct = (id, data) =>
  apiRequest(`/products.php?id=${id}`, { method: "PUT", body: data });

export const deleteProduct = (id) =>
  apiRequest(`/products.php?id=${id}`, { method: "DELETE" });

// Premi / Awards
export const listAwards = ({ all = false } = {}) =>
  apiRequest(`/awards.php${all ? "?all=1" : ""}`);

export const getAward = (id) => apiRequest(`/awards.php?id=${id}`);

export const createAward = (data) =>
  apiRequest("/awards.php", { method: "POST", body: data });

export const updateAward = (id, data) =>
  apiRequest(`/awards.php?id=${id}`, { method: "PUT", body: data });

export const deleteAward = (id) =>
  apiRequest(`/awards.php?id=${id}`, { method: "DELETE" });

// Brochure
export const listBrochures = ({ all = false } = {}) =>
  apiRequest(`/brochures.php${all ? "?all=1" : ""}`);

export const getBrochure = (id) => apiRequest(`/brochures.php?id=${id}`);

export const createBrochure = (data) =>
  apiRequest("/brochures.php", { method: "POST", body: data });

export const updateBrochure = (id, data) =>
  apiRequest(`/brochures.php?id=${id}`, { method: "PUT", body: data });

export const deleteBrochure = (id) =>
  apiRequest(`/brochures.php?id=${id}`, { method: "DELETE" });

// Upload file (immagine, PDF o video).
// kind: 'image' | 'pdf' | 'video' (opzionale — il server auto-detecta dal MIME)
export const uploadFile = (file, kind) => {
  const form = new FormData();
  form.append("file", file);
  if (kind) form.append("kind", kind);
  return apiRequest("/upload.php", {
    method: "POST",
    body: form,
    isMultipart: true,
  });
};

// Libreria media (immagini/PDF/video già caricati).
export const listMedia = ({ kind } = {}) => {
  const q = new URLSearchParams();
  if (kind) q.set("kind", kind);
  const qs = q.toString();
  return apiRequest(`/media.php${qs ? "?" + qs : ""}`);
};

export const deleteMedia = (id) =>
  apiRequest(`/media.php?id=${id}`, { method: "DELETE" });
